<template>
  <page :basic="true">
    <span slot="header">{{ headerText }}</span>

    <template slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
      <span v-if="role === 'owner' || role === 'master' || role === 'admin'">
        <router-link :to="{ name: adminView }">
          <i class="fas fa-exchange-alt"></i> Switch to Admin View
        </router-link>
      </span>
    </template>

    <div v-if="!selected" class="p-2">

      <div class="topic-header">
        <h4>{{ knowledgecheck.name }}</h4>
      </div>

      <br/>

      <div v-if="!fetching && !assigned && !inProgress" class="text-center">
        <b-button
          :disabled="fetching"
          variant="primary"
          @click.stop="create()"
        >
          Start Knowledge Check
        </b-button>
      </div>

      <div v-if="assigned" class="text-center">
        <b-button
          :disabled="fetching"
          variant="primary"
          @click.stop="startAssigned()"
        >
          Start Knowledge Check
        </b-button>

        <div v-if="assigned.due_date_time">
          Due by: {{ readableDate(assigned.due_date_time) }}
        </div>
      </div>

      <div v-if="inProgress" class="text-center">
        <b-button
          :disabled="fetching"
          variant="primary"
          @click.stop="continueInProgress()"
        >
          Continue existing knowledge check
        </b-button>
      </div>

      <br/>

      <completed
        v-if="!fetching"
        :items="completed"
        :response-view="responseView"/>

    </div>

    <div v-if="selected" class="p-2">
      <kc-form
        :item="selected"
        :default-params="defaultParams"
        :response-view="responseView"
      />
    </div>
  </page>
</template>

<script>
import _ from 'lodash'
import { readableDate } from '@/helpers'
import { mapState, mapGetters } from 'vuex'
import page from '../../../templates/page'
import api from '@/api/knowledgechecks/knowledgecheck'
import responseApi from '@/api/knowledgechecks/response'
import kcForm from './form'
import completed from './completed-table'

const defaultBreadcrumbs = [
  { text: 'Modules',to: { name: 'client-modules' } },
  { text: 'Components', to: { name: 'client-components' } },
  { text: 'Topics',to: { name: 'client-topics' } },
  { text: 'Knowledge Check', active: true }
]

export default {
  components:{
    completed,
    kcForm,
    page
  },
  props:{
    additionalRouteParams: { type: Object, default: () => {} },
    adminView: { type: String, default: 'admin-knowledgecheck' },
    breadcrumbs: { type: Array, default: () => defaultBreadcrumbs },
    headerText: { type: String, default: 'Knowledge Check' },
    responseView: { type: String, default: 'client-knowledgecheck-response-show' }
  },
  data(){
    return{
      assigned: null,
      completed: [],
      fetching: false,
      inProgress: null,
      responses: {},
      knowledgecheck:{},
      selected: null
    }
  },
  computed:{
    ...mapGetters('client', {
      role: 'getCurrentRole'
    }),
    ...mapState('tenants', {
      tenant: 'current'
    }),
    knowledgecheckId(){
      return this.knowledgecheck.id || this.$route.params.knowledgecheckId
    },
    preview () {
      return this.$route.query.preview
    },
    defaultParams(){
      return _.defaults({
        tenantId: this.tenant.id,
        knowledgecheckId: this.knowledgecheckId
      }, this.additionalRouteParams)
    }
  },
  watch:{
    knowledgecheckId(newValue){
      if(this.knowledgecheckId){
        this.load()
      }
    }
  },
  mounted(){
    if(this.knowledgecheckId){
      this.load()
    }
  },
  methods: {
    readableDate,
    async load(){
      if(!this.defaultParams.knowledgecheckId){
        return
      }

      this.fetching = true

      const kc_responsee = await api.show(this.defaultParams)
      this.knowledgecheck = kc_responsee.data.data

      const response = await responseApi.index(this.defaultParams)
      this.responses = response.data.data
      this.assigned = _.find(this.responses, (r) => {return r.status === 'assigned'})
      this.inProgress = _.find(this.responses, (r) => {return r.status === 'in-progress'})
      this.completed = _.filter(this.responses, (r) => {return r.status === 'completed'})

      this.fetching = false
    },
    async create(){
      if(!this.inProgress){
        this.fetching = true
        const params = _.clone(this.defaultParams)
        params.data = {}

        const created = await responseApi.store(params)
        const inProgress = created.data.data

        params.responseId = inProgress.id
        const response = await responseApi.show(params)
        this.selected = response.data.data

        this.inProgress = inProgress
        this.fetching =false
      }
    },
    async startAssigned(){
      if(this.assigned){
        this.fetching = true

        const params = _.clone(this.defaultParams)
        params.responseId = this.assigned.id

        const response = await responseApi.startAssigned(params)
        this.selected = response.data.data

        this.fetching = false
      }
    },
    async continueInProgress(){
      this.fetching = true

      const params = _.clone(this.defaultParams)
      params.responseId = this.inProgress.id

      const response = await responseApi.show(params)
      this.selected = response.data.data

      this.fetching = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/client/knowledge-checks/index.vue